import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { DialogModule, ToastModule, AuthorizeModule, LoginModule } from '@inera/common';

import { RoutingModule } from './module/routing';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RoutingModule,
    DialogModule,
    ToastModule,
    HttpClientModule,
    LoginModule,
    AuthorizeModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
